"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var helpers_exports = {};
__export(helpers_exports, {
  booleanFormatter: () => booleanFormatter,
  enumFormatter: () => enumFormatter,
  numberFormatter: () => numberFormatter,
  stringFormatter: () => stringFormatter,
  timestampFormatter: () => timestampFormatter,
  wrapBuckets: () => wrapBuckets
});
module.exports = __toCommonJS(helpers_exports);
var import_guard = require("@cartographerio/guard");
var import_types = require("@cartographerio/types");
var import_bucket = require("../bucket/index.js");
const DEFAULT_DECIMAL_PLACES = 2;
function wrapBuckets(buckets) {
  return buckets === "auto" ? (0, import_bucket.autoBuckets)({}) : (0, import_guard.isArray)(buckets) ? (0, import_bucket.standardBuckets)(buckets) : buckets;
}
const stringFormatter = (value) => (0, import_guard.isString)(value) ? value : null;
function enumFormatter(enumeration) {
  return (value) => enumeration.isValue(value) ? enumeration.labelOf(value) : null;
}
function numberFormatter(decimalPlaces = DEFAULT_DECIMAL_PLACES) {
  return (num) => (0, import_guard.isNumber)(num) ? num.toFixed(decimalPlaces) : null;
}
const booleanFormatter = (value) => (0, import_guard.isBoolean)(value) ? value === true ? "Yes" : "No" : null;
function timestampFormatter(format, timeZone) {
  return (epoch) => (0, import_guard.isNumber)(epoch) ? (0, import_types.formatTimestamp)((0, import_types.epochTimestamp)(epoch), { format, timeZone }) : null;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  booleanFormatter,
  enumFormatter,
  numberFormatter,
  stringFormatter,
  timestampFormatter,
  wrapBuckets
});
//# sourceMappingURL=helpers.js.map
